import MoveEvent from './MoveEvent';


let position = null;
let lastPosition = {
  x: 0,
  y: 0,
};

const emptyFunction = () => {};

const Movable = {
  DefaultValues: () => {
    return MoveEvent.DefaultValues();
  },

  events: ({ onMoveStart=emptyFunction,
             onMove=emptyFunction,
             onMoveEnd=emptyFunction}) => {

    const defaultOptions = {
      mouse: false,
      touch: true,
    };

    const startEvent = (pos) => {
      position = new MoveEvent(pos.x, pos.y);
      onMoveStart(position.toObject());
    };

    const moveEvent = (pos) => {
      position.addPoint(pos.x, pos.y);
      onMove(position.toObject());
    };

    const endEvent = (pos) => {
      position.addPoint(pos.x, pos.y);
      onMoveEnd(position.toObject());
    };

    const resultEvents = {};

    if (defaultOptions.mouse) {
      resultEvents.onDragStart = (e) => {
        const pos = {
          x: e.clientX,
          y: e.clientY,
        };
        startEvent(pos);
      };
      resultEvents.onDrag = (e) => {
        const pos = {
          x: e.clientX,
          y: e.clientY,
        };
        lastPosition = pos;
        moveEvent(pos);
      };
      resultEvents.onDragEnd = (e) => {
        const pos = lastPosition;
        endEvent(pos);
      };
    }

    if (defaultOptions.touch) {
      resultEvents.onTouchStart = (e) => {
        const pos = {
          x: e.changedTouches[0].clientX,
          y: e.changedTouches[0].clientY,
        };
        startEvent(pos);
      };
      resultEvents.onTouchMove = (e) => {
        const pos = {
          x: e.changedTouches[0].clientX,
          y: e.changedTouches[0].clientY,
        };
        lastPosition = pos;
        moveEvent(pos);
      };
      resultEvents.onTouchEnd = (e) => {
        const pos = {
          x: e.changedTouches[0].clientX,
          y: e.changedTouches[0].clientY,
        };
        endEvent(pos);
      };
    }

    return resultEvents;
  }
};

export default Movable;
